import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import { forwardRef } from 'react';
import { c as classNames } from '../../shared/index-20e0d875.js';
import { getTestId } from '../../utils/testId.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "flex": "web_ui__Flex__flex",
  "wrap": "web_ui__Flex__wrap",
  "row": "web_ui__Flex__row",
  "column": "web_ui__Flex__column",
  "flex--gap-none": "web_ui__Flex__flex--gap-none",
  "flex--gap-x-small": "web_ui__Flex__flex--gap-x-small",
  "flex--gap-small": "web_ui__Flex__flex--gap-small",
  "flex--gap-regular": "web_ui__Flex__flex--gap-regular",
  "flex--gap-medium": "web_ui__Flex__flex--gap-medium",
  "flex--gap-large": "web_ui__Flex__flex--gap-large",
  "flex--gap-larger": "web_ui__Flex__flex--gap-larger",
  "flex--gap-x-large": "web_ui__Flex__flex--gap-x-large",
  "flex--gap-x-larger": "web_ui__Flex__flex--gap-x-larger",
  "flex--gap-x2-large": "web_ui__Flex__flex--gap-x2-large",
  "flex--justify-center": "web_ui__Flex__flex--justify-center",
  "flex--justify-right": "web_ui__Flex__flex--justify-right",
  "flex--justify-left": "web_ui__Flex__flex--justify-left",
  "flex--justify-space-between": "web_ui__Flex__flex--justify-space-between",
  "flex--justify-space-around": "web_ui__Flex__flex--justify-space-around",
  "flex--justify-space-evenly": "web_ui__Flex__flex--justify-space-evenly",
  "flex--align-center": "web_ui__Flex__flex--align-center",
  "flex--align-top": "web_ui__Flex__flex--align-top",
  "flex--align-bottom": "web_ui__Flex__flex--align-bottom"
};

var Flex = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? 'left' : _ref$justify,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'top' : _ref$align,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 'none' : _ref$gap,
    _ref$wrap = _ref.wrap,
    wrap = _ref$wrap === void 0 ? false : _ref$wrap,
    testId = _ref.testId;
  var cssClasses = classNames.bind(styles);
  var flexClass = cssClasses([styles["flex--justify-".concat(justify)]], [styles["flex--align-".concat(align)]], [styles["flex--gap-".concat(gap)]], wrap && [[styles.wrap]]);
  var finalClass = classNames(styles.flex, flexClass, _defineProperty(_defineProperty({}, styles.row, direction === 'row'), styles.column, direction === 'column'));
  return /*#__PURE__*/jsx(Component, {
    className: finalClass,
    ref: ref,
    "data-testid": getTestId(testId, 'parent'),
    children: children
  });
});
Flex.displayName = 'Flex';

export { Flex as default };
//# sourceMappingURL=Flex.js.map
